import React from "react";

import Box from "@mui/material/Box";
import MUI_TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";

import ContentBox from "@components/ContentBox/ContentBox";
import searchIcon from "@assets/img/search_icon.svg";
import CustomerModal from "@cobComponents/CustomerModal/CustomerModal";
import AddCustomerModal from "@cobComponents/AddCustomerModal";

import useSessionsTable from "./useSessionsTable";
import DashboardTabs from "../DashboardTabs";
import DesktopTable from "./DesktopTable";
import MobileTable from "./MobileTable";

const SessionsTable = props => {
  const {
    user,
    type,
    modalWidget,
    partner,
    isLaptopOrDesktop,
    onMessage,
    onShareOpen,
    error,
    loaded,
    tabs,
    fetchingRowContent,
    copyList,
    numCases,
    page,
    setPage,
    searchString,
    setSearchString,
    order,
    orderBy,
    rowsPerPage,
    setRowsPerPage,
    setSelectedCustomer,
    handleChangePage,
    handleRequestSort,
    requestSearch,
    handleEntryClick,    
    onAction,
    currentAction,
    resetPaginationAndFilters,
    advisor,
    customerModalOpen,
    selectedCustomer,
    handleClientClick,
    handleClientModalClose,
    updateCustomers,
    caseFilterContext,
    addCustomerModalOpen,
    toggleAddCustomerModal,
    setCustomerState,
    isSession,
    onWorkflowSwitched,
    nextStepOptions
  } = useSessionsTable(props);

  return (
    <ContentBox
      style={{
        display: "inline",
        maxHeight: "70vh",
        boxShadow: "none",
        margin: 0,
        padding: 0
      }}
    >
      <Box 
        sx={{
          width: "100%",
          alignItems: "flex-start"
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {xs: "column", md: "row"},
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
          }}
        >
          <DashboardTabs 
            type="sessions" 
            translationGroup="dashboard_sessions"
            tabs={tabs}
            fetchingData={fetchingRowContent || !loaded}
            setPage={setPage}
            setSearchString={setSearchString}
            caseFilter={caseFilterContext.caseFilter}
            setCaseFilter={caseFilterContext.setCaseFilter}
          />
          <MUI_TextField
            size="small"
            placeholder="Sök..."
            type="search"
            onInput={e => requestSearch(e.target.value)}
            InputProps={{
              value: searchString,
              startAdornment: (
                <InputAdornment position="start">
                  <Box
                    component="img"
                    sx={{
                      height: 20,
                      width: 20,
                      paddingBottom: 0.25
                    }}
                    alt="logo"
                    src={searchIcon}
                  />
                </InputAdornment>
              ),
              sx: {
                px: 3,
                fontSize: "13px",
                borderRadius: "20px",
                width: "100%",
              }
            }}
            sx={{ 
              width: {xs: "100%", md: "30%"},
            }}
          />
        </Box>
        {isLaptopOrDesktop ? (
          <DesktopTable
            error={error}
            loaded={loaded}
            user={user}
            partner={partner}
            type={type}
            isSession={isSession}
            modalWidget={modalWidget}
            tabs={tabs}
            copyList={copyList}
            numCases={numCases}
            page={page}
            setPage={setPage}
            order={order}
            orderBy={orderBy}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            handleRequestSort={handleRequestSort}
            handleChangePage={handleChangePage}
            handleEntryClick={handleEntryClick}
            handleClientClick={handleClientClick}
            onAction={onAction}       
            onMessage={onMessage}
            onShareOpen={onShareOpen}
            currentAction={currentAction}
            resetPaginationAndFilters={resetPaginationAndFilters}
          />            
        ) : (
          <MobileTable
            error={error}
            loaded={loaded}
            user={user}
            partner={partner}
            type={type}
            isSession={isSession}
            modalWidget={modalWidget}
            tabs={tabs}
            copyList={copyList}
            numCases={numCases}
            page={page}
            setPage={setPage}
            order={order}
            orderBy={orderBy}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            handleRequestSort={handleRequestSort}
            handleChangePage={handleChangePage}
            handleEntryClick={handleEntryClick}
            handleClientClick={handleClientClick}
            onAction={onAction}       
            onMessage={onMessage}
            onShareOpen={onShareOpen}
            currentAction={currentAction}
            resetPaginationAndFilters={resetPaginationAndFilters}
          /> 
        )}
      </Box>
      {(customerModalOpen && selectedCustomer) && (
        <CustomerModal
          view="overview"
          visible={true}
          user={user}
          partner={partner}
          advisor={advisor}
          client={selectedCustomer}          
          onClose={handleClientModalClose}
          updateCustomers={updateCustomers}
          caseFilterContext={caseFilterContext}
          addCustomerModalOpen={addCustomerModalOpen}
          toggleAddCustomerModal={toggleAddCustomerModal}
          setCustomerState={setCustomerState}
          onWorkflowSwitched={onWorkflowSwitched}
          nextStepOptions={nextStepOptions}
          setSelectedCustomer={setSelectedCustomer}
        />
      )}
      {addCustomerModalOpen && (
        <AddCustomerModal
          open={addCustomerModalOpen}
          toggleModal={toggleAddCustomerModal}
          customer={selectedCustomer}
          userData={{personal_number: advisor.ssn, role: advisor.role}}
          updateCustomers={updateCustomers}
          allowNoCustomerId={partner._data.allowNoCustomerId}
        />
      )}
    </ContentBox>
  );
};

export default SessionsTable;